import PropTypes from 'prop-types'
import { useState, useEffect, useRef } from 'react'
import { useFormContext } from 'react-hook-form'

// Internal component
import Svg from '../Svg/Svg'

const FilterDropdown = (props) => {
  const { filter, triggerFilters, clear, defaultValue } = props

  const { register, setValue, trigger } = useFormContext()

  const [selected, setSelected] = useState(false)
  const [title, setTitle] = useState(filter.title)

  const dropdownRef = useRef()
  const dropdownDefaultRef = useRef()

  useEffect(() => {
    const dropdown = dropdownRef.current
    if (defaultValue && dropdown) {
      const filterTitle = dropdown.options[dropdown.selectedIndex]?.dataset.active || filter.title
      setTitle(filterTitle)
      setValue(filter.name, defaultValue)
      setSelected(filterTitle !== filter.title)
    }
  }, [defaultValue])

  useEffect(() => {
    if (selected) resetFilter()
  }, [clear])

  const onChange = (e) => {
    const dropdown = e.currentTarget
    if (dropdown?.selectedIndex) {
      setTitle(dropdown.options[dropdown.selectedIndex].dataset.active)
      setSelected(true)
      setValue(filter.name, dropdown.value)
      triggerFilters()
    } else {
      resetFilter()
    }
  }

  const resetFilter = (name) => {
    setSelected(false)
    setTitle(filter.title)
    setValue(filter.name, '')
    dropdownDefaultRef.current.selected = true
    trigger()
    triggerFilters()
  }

  return (
    <div className={`FilterDropdown ${selected ? 'is-selected' : ''}`}>
      <div className="FilterDropdown-clear" onClick={() => resetFilter(filter.name)}>
        <Svg id="icon-close" />
      </div>
      <label className="FilterDropdown-label" htmlFor={filter.id}>
        <div className="FilterDropdown-text">
          <span className="FilterDropdown-title">{title}</span>
        </div>
        <div className="FilterDropdown-icon">
          <Svg id="icon-chevron-down" />
        </div>
        <div className="FilterDropdown-input">
          <select
            className="FilterDropdown-select"
            defaultValue={defaultValue || 0}
            id={filter.id}
            name={filter.name}
            {...register(filter.name)}
            ref={dropdownRef}
            onChange={(e) => onChange(e)}
          >
            {filter.default && (
              <option ref={dropdownDefaultRef} value="" key="OverviewFilter-option--0">
                {filter.default}
              </option>
            )}
            {filter.options.length &&
              filter.options.map((option, index) => {
                return (
                  <option
                    value={option.value}
                    data-active={option.active}
                    disabled={option.disabled}
                    key={`OverviewFilter-option--${index + 1}`}
                  >
                    {option.label}
                  </option>
                )
              })}
          </select>
        </div>
      </label>
    </div>
  )
}

FilterDropdown.propTypes = {
  defaultValue: PropTypes.string,
  filter: PropTypes.array,
  triggerFilters: PropTypes.func,
  clear: PropTypes.any
}

export default FilterDropdown
